var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 27
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ic-wallet_svg__a",
    x1: "89.052%",
    x2: "2.642%",
    y1: "42.587%",
    y2: "56.737%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF684A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF4959"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ic-wallet_svg__b",
    x1: "89.052%",
    x2: "2.642%",
    y1: "20.798%",
    y2: "76.538%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFC800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF9500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ic-wallet_svg__c",
    x1: "89.052%",
    x2: "2.642%",
    y1: "23.7%",
    y2: "73.901%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFC800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF9500"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(2.12 2.12)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#ic-wallet_svg__a)",
    stroke: "#3B385E",
    strokeWidth: 1.394,
    d: "M.97 7.254l10.987-4.401c.95-.381 2.03.079 2.414 1.028l1.915 4.735h0",
    transform: "rotate(-20 8.628 5.668)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ic-wallet_svg__a)",
    stroke: "#3B385E",
    strokeWidth: 1.394,
    d: "M4.602 8.653l10.987-4.401c.95-.381 2.03.079 2.414 1.028l1.915 4.735h0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20.499,
    height: 15.666,
    x: 1.398,
    y: 7.634,
    fill: "url(#ic-wallet_svg__b)",
    stroke: "#3B385E",
    strokeWidth: 1.394,
    rx: 1.859
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.988,
    height: 5.068,
    x: 16.772,
    y: 12.702,
    fill: "url(#ic-wallet_svg__c)",
    stroke: "#3B385E",
    strokeWidth: 1.394,
    rx: 0.929
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.266,
    cy: 15.236,
    fill: "#3B385E",
    rx: 1.165,
    ry: 1.152
  }))));
}
export default SvgIcWallet;